module.exports = __webpack_public_path__ + "static/media/add-logo-desktop-es.a126fcb2.png";